import { render, staticRenderFns } from "./BoxAdminCom.vue?vue&type=template&id=6981c51a&"
import script from "./BoxAdminCom.vue?vue&type=script&lang=ts&"
export * from "./BoxAdminCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports